import { withRouter } from 'react-router-dom';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withSize } from 'react-sizeme';

import JobsContainer from './JobsContainer';
import JobsView from './JobsView';

import { providers } from '../../store/jobs/jobsReducers';

export { JobsView, JobsContainer };

// by default we only pull in the user state - expand as needed
const mapStateToProps = (state = {}) => ({
  ...state.jobs,
  ...state.users,
});

const mapDispatchToProps = dispatch => Object.keys(providers)
  .reduce((dispatcher, name) => ({ ...dispatcher, [name]: (...args) => dispatch(providers[name](...args)) }), {});

const View = connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(JobsContainer));

class Sizer extends Component {
  render() {
    return <View {...this.props} />;
  }
}

export default withSize({ monitorHeight: true, refreshMode: 'debounce', refreshRate: 32 })(Sizer);
